import { render, staticRenderFns } from "./GenericAPIDevPage.vue?vue&type=template&id=4978bcc8&"
import script from "./GenericAPIDevPage.vue?vue&type=script&lang=js&"
export * from "./GenericAPIDevPage.vue?vue&type=script&lang=js&"
import style0 from "./GenericAPIDevPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports